const BORDER = '#2373ce';
const FILL = '#0c1ae2';

export const getCircleOptions = ({ center, map, radius }) => ({
  center,
  fillColor: FILL,
  fillOpacity: 0.5,
  map,
  radius,
  strokeColor: BORDER,
  strokeOpacity: 0.8,
  strokeWeight: 2,
});

export const getMapOptions = ({ zoom, center }) => ({
  zoom,
  center,
  mapTypeControl: false,
  streetViewControl: false,
  styles: [
    {
      featureType: 'poi',
      stylers: [{ visibility: 'off' }],
    },
    {
      featureType: 'transit',
      elementType: 'labels.icon',
      stylers: [{ visibility: 'off' }],
    },
  ],
});
